import { render } from "./ActionButton.vue?vue&type=template&id=c54674aa&ts=true"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3346310468/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__